"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitionControllerListCompetitionsV1TypeEnum = exports.AdminCompetitionApi = exports.AdminCompetitionApiFactory = exports.AdminCompetitionApiFp = exports.AdminCompetitionApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * AdminCompetitionApi - axios parameter creator
 * @export
 */
var AdminCompetitionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a competition
         * @param {CreateCompetitionDto} createCompetitionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerCreateCompetitionV1: function (createCompetitionDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createCompetitionDto_1], args_1, true), void 0, function (createCompetitionDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createCompetitionDto' is not null or undefined
                            (0, common_1.assertParamExists)('competitionControllerCreateCompetitionV1', 'createCompetitionDto', createCompetitionDto);
                            localVarPath = "/v1/admin/competition";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCompetitionDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a recently published competition (within 10 minutes)
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerDeleteCompetitionV1: function (competitionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([competitionId_1], args_1, true), void 0, function (competitionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'competitionId' is not null or undefined
                            (0, common_1.assertParamExists)('competitionControllerDeleteCompetitionV1', 'competitionId', competitionId);
                            localVarPath = "/v1/admin/competition/{competitionId}"
                                .replace("{".concat("competitionId", "}"), encodeURIComponent(String(competitionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Edit a competition
         * @param {string} competitionId
         * @param {EditCompetitionDto} editCompetitionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerEditCompetitionV1: function (competitionId_1, editCompetitionDto_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([competitionId_1, editCompetitionDto_1], args_1, true), void 0, function (competitionId, editCompetitionDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'competitionId' is not null or undefined
                            (0, common_1.assertParamExists)('competitionControllerEditCompetitionV1', 'competitionId', competitionId);
                            // verify required parameter 'editCompetitionDto' is not null or undefined
                            (0, common_1.assertParamExists)('competitionControllerEditCompetitionV1', 'editCompetitionDto', editCompetitionDto);
                            localVarPath = "/v1/admin/competition/{competitionId}"
                                .replace("{".concat("competitionId", "}"), encodeURIComponent(String(competitionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(editCompetitionDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a competition by id
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerGetCompetitionV1: function (competitionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([competitionId_1], args_1, true), void 0, function (competitionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'competitionId' is not null or undefined
                            (0, common_1.assertParamExists)('competitionControllerGetCompetitionV1', 'competitionId', competitionId);
                            localVarPath = "/v1/admin/competition/{competitionId}"
                                .replace("{".concat("competitionId", "}"), encodeURIComponent(String(competitionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List winners with details for a completed competition
         * @param {string} competitionId
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListCompetitionWinnersV1: function (competitionId_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([competitionId_1, page_1, limit_1], args_1, true), void 0, function (competitionId, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'competitionId' is not null or undefined
                            (0, common_1.assertParamExists)('competitionControllerListCompetitionWinnersV1', 'competitionId', competitionId);
                            localVarPath = "/v1/admin/competition/{competitionId}/winners"
                                .replace("{".concat("competitionId", "}"), encodeURIComponent(String(competitionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List competitions
         * @param {number} [page] Page number
         * @param {number} [limit] Page size
         * @param {Array<string>} [status] One or more competition statuses (comma‑separated or repeatable). Use \&quot;all\&quot; to disable status filtering.
         * @param {CompetitionControllerListCompetitionsV1TypeEnum} [type] Competition type
         * @param {Array<string>} [categoryIds] Multiple category ids
         * @param {string} [search] Search competition title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListCompetitionsV1: function (page_1, limit_1, status_1, type_1, categoryIds_1, search_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, limit_1, status_1, type_1, categoryIds_1, search_1], args_1, true), void 0, function (page, limit, status, type, categoryIds, search, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/admin/competition";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            if (categoryIds) {
                                localVarQueryParameter['categoryIds'] = categoryIds;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List competition types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListTypesV1: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/admin/competition/types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AdminCompetitionApiAxiosParamCreator = AdminCompetitionApiAxiosParamCreator;
/**
 * AdminCompetitionApi - functional programming interface
 * @export
 */
var AdminCompetitionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminCompetitionApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a competition
         * @param {CreateCompetitionDto} createCompetitionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerCreateCompetitionV1: function (createCompetitionDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.competitionControllerCreateCompetitionV1(createCompetitionDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminCompetitionApi.competitionControllerCreateCompetitionV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a recently published competition (within 10 minutes)
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerDeleteCompetitionV1: function (competitionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.competitionControllerDeleteCompetitionV1(competitionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminCompetitionApi.competitionControllerDeleteCompetitionV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Edit a competition
         * @param {string} competitionId
         * @param {EditCompetitionDto} editCompetitionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerEditCompetitionV1: function (competitionId, editCompetitionDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.competitionControllerEditCompetitionV1(competitionId, editCompetitionDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminCompetitionApi.competitionControllerEditCompetitionV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a competition by id
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerGetCompetitionV1: function (competitionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.competitionControllerGetCompetitionV1(competitionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminCompetitionApi.competitionControllerGetCompetitionV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List winners with details for a completed competition
         * @param {string} competitionId
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListCompetitionWinnersV1: function (competitionId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.competitionControllerListCompetitionWinnersV1(competitionId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminCompetitionApi.competitionControllerListCompetitionWinnersV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List competitions
         * @param {number} [page] Page number
         * @param {number} [limit] Page size
         * @param {Array<string>} [status] One or more competition statuses (comma‑separated or repeatable). Use \&quot;all\&quot; to disable status filtering.
         * @param {CompetitionControllerListCompetitionsV1TypeEnum} [type] Competition type
         * @param {Array<string>} [categoryIds] Multiple category ids
         * @param {string} [search] Search competition title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListCompetitionsV1: function (page, limit, status, type, categoryIds, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.competitionControllerListCompetitionsV1(page, limit, status, type, categoryIds, search, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminCompetitionApi.competitionControllerListCompetitionsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List competition types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListTypesV1: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.competitionControllerListTypesV1(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminCompetitionApi.competitionControllerListTypesV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AdminCompetitionApiFp = AdminCompetitionApiFp;
/**
 * AdminCompetitionApi - factory interface
 * @export
 */
var AdminCompetitionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminCompetitionApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a competition
         * @param {CreateCompetitionDto} createCompetitionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerCreateCompetitionV1: function (createCompetitionDto, options) {
            return localVarFp.competitionControllerCreateCompetitionV1(createCompetitionDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a recently published competition (within 10 minutes)
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerDeleteCompetitionV1: function (competitionId, options) {
            return localVarFp.competitionControllerDeleteCompetitionV1(competitionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Edit a competition
         * @param {string} competitionId
         * @param {EditCompetitionDto} editCompetitionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerEditCompetitionV1: function (competitionId, editCompetitionDto, options) {
            return localVarFp.competitionControllerEditCompetitionV1(competitionId, editCompetitionDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a competition by id
         * @param {string} competitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerGetCompetitionV1: function (competitionId, options) {
            return localVarFp.competitionControllerGetCompetitionV1(competitionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List winners with details for a completed competition
         * @param {string} competitionId
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListCompetitionWinnersV1: function (competitionId, page, limit, options) {
            return localVarFp.competitionControllerListCompetitionWinnersV1(competitionId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List competitions
         * @param {number} [page] Page number
         * @param {number} [limit] Page size
         * @param {Array<string>} [status] One or more competition statuses (comma‑separated or repeatable). Use \&quot;all\&quot; to disable status filtering.
         * @param {CompetitionControllerListCompetitionsV1TypeEnum} [type] Competition type
         * @param {Array<string>} [categoryIds] Multiple category ids
         * @param {string} [search] Search competition title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListCompetitionsV1: function (page, limit, status, type, categoryIds, search, options) {
            return localVarFp.competitionControllerListCompetitionsV1(page, limit, status, type, categoryIds, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List competition types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionControllerListTypesV1: function (options) {
            return localVarFp.competitionControllerListTypesV1(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminCompetitionApiFactory = AdminCompetitionApiFactory;
/**
 * AdminCompetitionApi - object-oriented interface
 * @export
 * @class AdminCompetitionApi
 * @extends {BaseAPI}
 */
var AdminCompetitionApi = /** @class */ (function (_super) {
    __extends(AdminCompetitionApi, _super);
    function AdminCompetitionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a competition
     * @param {CreateCompetitionDto} createCompetitionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCompetitionApi
     */
    AdminCompetitionApi.prototype.competitionControllerCreateCompetitionV1 = function (createCompetitionDto, options) {
        var _this = this;
        return (0, exports.AdminCompetitionApiFp)(this.configuration).competitionControllerCreateCompetitionV1(createCompetitionDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a recently published competition (within 10 minutes)
     * @param {string} competitionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCompetitionApi
     */
    AdminCompetitionApi.prototype.competitionControllerDeleteCompetitionV1 = function (competitionId, options) {
        var _this = this;
        return (0, exports.AdminCompetitionApiFp)(this.configuration).competitionControllerDeleteCompetitionV1(competitionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Edit a competition
     * @param {string} competitionId
     * @param {EditCompetitionDto} editCompetitionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCompetitionApi
     */
    AdminCompetitionApi.prototype.competitionControllerEditCompetitionV1 = function (competitionId, editCompetitionDto, options) {
        var _this = this;
        return (0, exports.AdminCompetitionApiFp)(this.configuration).competitionControllerEditCompetitionV1(competitionId, editCompetitionDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a competition by id
     * @param {string} competitionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCompetitionApi
     */
    AdminCompetitionApi.prototype.competitionControllerGetCompetitionV1 = function (competitionId, options) {
        var _this = this;
        return (0, exports.AdminCompetitionApiFp)(this.configuration).competitionControllerGetCompetitionV1(competitionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List winners with details for a completed competition
     * @param {string} competitionId
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Items per page (default: 20)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCompetitionApi
     */
    AdminCompetitionApi.prototype.competitionControllerListCompetitionWinnersV1 = function (competitionId, page, limit, options) {
        var _this = this;
        return (0, exports.AdminCompetitionApiFp)(this.configuration).competitionControllerListCompetitionWinnersV1(competitionId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List competitions
     * @param {number} [page] Page number
     * @param {number} [limit] Page size
     * @param {Array<string>} [status] One or more competition statuses (comma‑separated or repeatable). Use \&quot;all\&quot; to disable status filtering.
     * @param {CompetitionControllerListCompetitionsV1TypeEnum} [type] Competition type
     * @param {Array<string>} [categoryIds] Multiple category ids
     * @param {string} [search] Search competition title
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCompetitionApi
     */
    AdminCompetitionApi.prototype.competitionControllerListCompetitionsV1 = function (page, limit, status, type, categoryIds, search, options) {
        var _this = this;
        return (0, exports.AdminCompetitionApiFp)(this.configuration).competitionControllerListCompetitionsV1(page, limit, status, type, categoryIds, search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List competition types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCompetitionApi
     */
    AdminCompetitionApi.prototype.competitionControllerListTypesV1 = function (options) {
        var _this = this;
        return (0, exports.AdminCompetitionApiFp)(this.configuration).competitionControllerListTypesV1(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminCompetitionApi;
}(base_1.BaseAPI));
exports.AdminCompetitionApi = AdminCompetitionApi;
/**
 * @export
 */
exports.CompetitionControllerListCompetitionsV1TypeEnum = {
    Paid: 'paid',
    Free: 'free'
};
